import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { GetAutoPaySequenceService } from 'src/app/shared/services/api/get-auto-pay-sequence.service';

@Component({
  selector: 'app-auto-pay-dialog',
  templateUrl: './auto-pay-dialog.component.html',
  styleUrls: ['./auto-pay-dialog.component.scss']
})
export class AutoPayDialogComponent {
  currentSelection: any;
  autopayOptions: any;
  primaryAutoPayMethod: any;   // 🔑 now points to wallet.primaryAutoPay
  isAutoPay: boolean;
  toggleChanged: boolean;
  skipFirstStep: boolean;
  skipConfirmation: boolean;

  systemError: boolean = false;
  buttonLoading: boolean = false;
  currentStep: number = 0;

  @Output() autopayResult = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<AutoPayDialogComponent>,
    public router: Router,
    public route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private getAutoPaySequence: GetAutoPaySequenceService
  ) {
    this.currentSelection = data?.currentSelection;
    this.autopayOptions = data?.autopayOptions;
    this.primaryAutoPayMethod = data?.primaryAutoPay || null;  // ✅ expect primaryAutoPay passed in
    this.isAutoPay = data?.isAutoPay;
    this.skipFirstStep = data?.skipFirstStep || false;
    this.toggleChanged = data?.toggleChanged || false;
    this.skipConfirmation = data?.skipConfirmation || false;

    if (this.skipConfirmation) {
      this.currentStep = 1;
    }

    if (this.skipFirstStep) {
      this.currentStep = 1;
    }
  }

  confirmRedeem() {
    this.buttonLoading = true;

    // Build payload specifically for PPI AutoPay
    const payload: any = {
      walletID: this.currentSelection.walletID,
      walletRole: this.currentSelection.walletRole || 'admin',
      sourceSystemID1: sessionStorage.getItem("PPICustomerID"),
      isAutoPay: this.isAutoPay,
      productSystem: 'PPI',
      sessionID: this.currentSelection.sessionID,
      customerID: this.currentSelection.customerID,
      userID: this.currentSelection.userID,
      billingSystem: 'PPI',
      payorID: '',
      // 🔑 use Primary AutoPay card token, not Default
     // defaultPaymentMethodToken: this.primaryAutoPayMethod?.token || this.currentSelection.defaultPaymentMethodToken
    };

if (this.isAutoPay) {
  payload.defaultPaymentMethodToken =
    this.primaryAutoPayMethod?.token || this.currentSelection.defaultPaymentMethodToken;
}

    this.getAutoPaySequence.setPpiAutoPay(payload).subscribe(
      (data) => {
        this.buttonLoading = false;
        if (data.success || data.statusCode === '200') {
          this.currentStep = 1; // Update Confirmed
          this.autopayResult.emit(this.isAutoPay);
        } else {
          console.error('DEBUG AutoPay failed payload:', payload, 'response:', data);
          this.systemError = true;
          this.autopayResult.emit(false);
        }
      },
      (error) => {
        this.buttonLoading = false;
        console.error('DEBUG AutoPay failed payload:', payload, 'error:', error);
        this.systemError = true;
        this.autopayResult.emit(false);
      }
    );
  }

  close() {
    this.autopayResult.emit('cancel');
    this.dialogRef.close();
  }

  thankYou() {
    this.dialogRef.close();
  }
}
